import { Box, Button, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import styles from "./about.module.css";
import Contact from "./Contact";
import resume from "../Images/Aslam-Mahetar-Resume.pdf";
import {
  AiFillLinkedin,
  AiFillMail,
  AiFillPhone,
  AiOutlineGithub,
} from "react-icons/ai";
import { Link } from "react-router-dom";

function About() {
  return (
    <Box id="about" className="about section">
      <Box
        w={"90%"}
        m={"auto"}
        display={"flex"}
        flexDirection={{
          base: "column-reverse",
          sm: "column-reverse",
          md: "column-reverse",
          xl: "row",
        }}
        justifyContent={"space-between"}
        alignItems={"center"}
        mt={"120px"}
      >
        <Box textAlign={"left"} w={"50%"}>
          <Heading as={"h1"} size={"2xl"}>
            Hii I Am
          </Heading>
          <Heading
            as={"h1"}
            size={"2xl"}
            color={"#89CFF0"}
            id="user-detail-name"
          >
            Aslam M Mahetar
          </Heading>
          <Heading as={"h1"} size={"2xl"} color={"#89CFF0"}>
            A Full stack web developer
          </Heading>
          <br />
          <Heading as={"h2"} size={"md"}>
            About me:
          </Heading>
          <Text fontSize={"19px"} color={"grey"} id="user-detail-intro">
            A Passionate full-stack web developer, Who loves to build cool and
            chellenging projects and want to achive best version of him self
            <br />
            <br />
            <Contact />
            <Button
              id="resume-button-2"
              colorScheme="blue"
              onClick={() =>
                window.open(
                  "https://drive.google.com/file/d/1ydk5O-TOfKJSXTVDgWYc9kNj1fgC4RIB/view?usp=drive_link"
                )
              }
            >
              <a
                href={resume}
                id="resume-link-2"
                download={"Aslam-M-Mahetar Resume"}
              >
                My Resume
              </a>
            </Button>
            <br />
            <Heading as={"h3"} size={"md"} mt={"5"} color={"black"}>
              Contact me
            </Heading>
            <Box mt={"3"}>
              <Link
                to={"https://www.linkedin.com/in/aslam-m-mahetar-b2081824b/"}
                target="_blank"
              >
                <Button color={"black"} id="contact-linkedin">
                  <AiFillLinkedin />
                </Button>
              </Link>
              <Link to={"https://github.com/aslammmahetar"} target="_blank">
                <Button ml={"5"} color={"black"} id="contact-github">
                  <AiOutlineGithub />
                </Button>
              </Link>
              <Link to={"mailto: mmahetaraslam@gmail.com"} target="_blank">
                <Button ml={"5"} color={"black"} id="contact-email">
                  <AiFillMail />
                </Button>
              </Link>
              <Link to={"callto: +919106353530"} target="_blank">
                <Button ml={"5"} color={"black"} id="contact-phone">
                  <AiFillPhone />
                  +91 9106353530
                </Button>
              </Link>
            </Box>
          </Text>
        </Box>
        <Box w={"35%"} display={"flex"} justifyContent={"center"}>
          <Image
            className="home-img"
            transition={"transform .2s;"}
            src="https://avatars.githubusercontent.com/u/115460260?s=400&u=33aed1fe3134a969683fdfdef5d61e8282c31005&v=4"
            borderRadius={"50%"}
          ></Image>
        </Box>
      </Box>
      <Box className={styles.quote} p={"20px"} mt={"50px"}>
        <Box p={"10"}>
          <Heading as={"h1"} size={"xl"} color={"#89CFF0"}>
            Code is poetry
          </Heading>
          <Heading as={"h1"} size={"xl"} color={"white"}>
            And Developer are the artists who bring it to life.
          </Heading>
        </Box>
      </Box>
    </Box>
  );
}

export default About;
